import { render, staticRenderFns } from "./ReviewListing.vue?vue&type=template&id=429c760a&scoped=true"
import script from "./ReviewListing.vue?vue&type=script&lang=js"
export * from "./ReviewListing.vue?vue&type=script&lang=js"
import style0 from "./ReviewListing.vue?vue&type=style&index=0&id=429c760a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429c760a",
  null
  
)

export default component.exports